// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GwZn","placeholdersHeader":"styles_placeholdersHeader__y10iE","editorStyle":"styles_editorStyle__cYPkI","placeholdersBox":"styles_placeholdersBox__iVuQx"};